import React from "react";

import axios2 from 'services/axios2';

import {useParams} from "react-router-dom";
import {Link,hashHistory} from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';

import NuLoading from 'components/nubox/NuLoading'; 

import user from 'assets/img/user.jpg';

import {
  Table,
  Button,
  Container,
  Modal,
  ModalHeader,
  ModalBody,
  FormGroup,
  ModalFooter,
  ToastHeader,
} from "reactstrap";

const initialForm={
  idd:0,
  ope:'n',

  mate_sn:0,
  doc_sn:0,
  estud_sn:0,
  clave:'',
}

/*$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$*/
class Reset extends React.Component {  

  state = {

    isLoading:false,

    form: initialForm,
    data: [],/* lista resultado  */
    
  };
  //--------------------------------------
  constructor(props) {
    super(props);
  
    this.refNuConfirm = React.createRef();
    this.modalRef = React.createRef();//create ref
  }
  //------------------------------------------------------
  componentDidMount() {
    //--limpiamos el array de prueba
    this.setState({data:[]});

    const date = new Date();
    const defaultValue = date.toLocaleDateString('en-CA');
  
    //this.setState({fechai: defaultValue}); 
    //this.setState({ form:{...this.state.form, fecha: defaultValue,}}); 

    //this.cargar_globalx();
    
    //this.cargar_citas();
    //this.fetchData(this.state.fechai);
  }

  //------------ cambiamos la fecha
  /*handleChange = event =>{
    this.setState({ name: event.target.value});
  }*/
  //----------------especial, actualiza valores del form -------------------------------
  handleChangeForm = (e) => {
    //requerimos la prop name="?" en cada control
    this.setState({
      form: {
        ...this.state.form,
        [e.target.name]: e.target.value,
      },
    });
  };
  handleChangeCheck = (e) => {
    //
    //console.log(e.target.checked);
    //e.target.checked = !e.target.checked
    console.log(e.target.checked)
    let res = e.target.checked ===true? 1:0;
    this.setState({
      form: { ...this.state.form,
        [e.target.name]: res,
      },
    });
  };
  
  //====================================================== 
  //----cargamos los datos desde la base de datos
  /*{
    "id_medico": 1,
        "nombre": "Dr. Gerson Abner Villafuerte Oporto",
        "dir": "",
        "tel": "",
        "cel": "",
        "foto_path1": ""
        "especialidad": "Ortodoncia"
  },*/
  /*cargar_globalx = () => {
    let param = { 
      
    }
    
    axios2.post(process.env.REACT_APP_API_URL  + "globalx_get_global", param)
    .then(res => {
      //console.log(res.data);

        if(res.data !== null ){ 
            //toast.success("Correcto");
            console.log(res.data);
            this.setState({form: res.data});
            //console.log(this.state.medicos);
        }else{
            this.setState({form: initialForm});
        }

    }).catch(error => {
        alert("---- Existio un error ---");
        console.log(error);
        
    });
  };/*
      
  imprimir =(id_certi)=>{
    let fileURL = process.env.REACT_APP_API_URL  + "certificado_reciboPDF/"+ id_certi;
    let  windowFeatures = 'width=650,height= 700, left=100,top=100 ';
    window.open(fileURL,'',windowFeatures);
  }
  //----------------
  
  /* === This is where the magic happens ==== */
  handleSubmit = event => {
    event.preventDefault();
    //this.cargar_globalx();
  }
  /************************************************ */
 

  save =() =>{
  
    //let param =  {};
    let param =  this.state.form;
    param.idd =1;
    param.ope ='n';
    
    //console.log(process.env.REACT_APP_API_URL);
    
    this.setState({ isLoading: true })
    console.log(param)
    axios2.post(process.env.REACT_APP_API_URL  + "reset_store", param)
    .then(res => {

        this.setState({ isLoading: false })
        console.log(res.data)
        
        if(res.data.exito === 1){ 
            //toast.success(res.data.mensaje);
            this.setState({ divres : res.data.men });
            this.setState({ data: res.data.tabla })
        }else{
            console.log(res.data.men)
            toast.error(res.data.men);
        }

    }).catch(error => {
        alert("---- Existio un error ---");
        console.log(error);
        
    });
  
  }
  //-------------------------------------
  render() {
    
    return (
      <div>
        <ToastContainer />
        <div className="content">

          {
            //JSON.stringify(this.state.form)
          }
          {/*<!--- ------------------------------->*/}
          <div className="row justify-content-center">

            <div className="col-md-6">
              
              <form onSubmit={this.handleSubmit}>

                {/*<!-- general form elements -->*/}
                <div className="card card-primary">
                  <div className="card-header">
                    <h3 className="card-title">Reinicio de sistema</h3>
                  </div>
                  {/*<!-- /.card-header -->*/}

                  <div className="card-body1">

                    {/*<!-- aqui el panel principal-->*/}
                    <div className="content bg-grey">

                      <table className="tabla04" width="100%">
                        {/*<!-- caption -->*/}
                        <tbody>

                          {/*<!-- ............................. -->*/}
                          <tr>
                            <td className="celda-blue" colSpan="2">Autorización</td>

                          </tr>

                          <tr>
                            <td colSpan="2">
                              <div className="checkbox">
                                <label style={{ fontWeight: 'normal' }}>

                                  <input className="form-check-input" type="checkbox" role="switch"
                                    name="mate_sn"
                                    value={this.state.form.mate_sn}
                                    checked={this.state.form.mate_sn === 1}
                                    onChange={this.handleChangeCheck}
                                  />&nbsp;&nbsp;
                                  Asignaturas
                                </label>


                              </div>
                              <div className="checkbox">
                                <label style={{ fontWeight: 'normal' }}>

                                  <input className="form-check-input" type="checkbox" role="switch"
                                    name="doc_sn"
                                    value={this.state.form.doc_sn }
                                    checked={this.state.form.doc_sn === 1}
                                    onChange={this.handleChangeCheck}
                                  />&nbsp;&nbsp;
                                  Docentes
                                </label>
                              </div>
                              <div className="checkbox">
                                <label style={{ fontWeight: 'normal' }}>

                                  <input className="form-check-input" type="checkbox" role="switch"
                                    name="estud_sn"
                                    value={this.state.form.estud_sn }
                                    checked={this.state.form.estud_sn === 1}
                                    onChange={this.handleChangeCheck}
                                  />&nbsp;&nbsp;
                                  Estudiantes
                                </label>
                              </div>
                            </td>
                          </tr>

                          <tr>
                            <td><span className="data_error">*</span> Clave:</td>
                            <td>
                              <input
                                type="password"
                                className="form-control input-sm"
                                style={{ width: '150px' }}
                                name="clave"
                                value={this.state.form.clave}
                                onChange={this.handleChangeForm}
                              />
                            </td>
                          </tr>

                          {/*<!------------------------------------------------------------------------>*/}

                          <tr>
                            <td className="celda-blue" colSpan="2">Consola de salida</td>

                          </tr>

                        </tbody>
                      </table>

                    </div>

                  </div>
                  {/*<!-- /.card-body -->*/}

                  <div className="card-footer text-center">
                    <button className="btn btn-primary"
                      onClick={()=>this.save()} >Guardar</button>
                  </div>

                  {/*<!-- resultado jquery-->*/}
                  <NuLoading text="Cargando...." show= { this.state.isLoading }/>
                  
                    <div class="panel panel-success">
                      <div class="panel-heading">
                        Resultado
                      </div>
                      <ul class="list-group">
                        { this.state.data.map((item,index) =>(
                            
                            <li key={index} class="list-group-item">{ item }</li>
                          ))
                        }
                      </ul>
                    </div>
                  </div>
                
                {/*<!-- /.card -->*/}

              </form>
            </div>

          </div>

          {/*<!-- -------------------------------------------------->*/}

        </div>

      </div>
    );
  }
}
  
export default Reset;